import { render } from "./ViewAttach.vue?vue&type=template&id=327af86a&scoped=true"
import script from "./ViewAttach.vue?vue&type=script&lang=js"
export * from "./ViewAttach.vue?vue&type=script&lang=js"

import "./ViewAttach.vue?vue&type=style&index=0&id=327af86a&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327af86a"]])

export default __exports__